function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6682 55.5249C21.6277 55.5249 24.8374 52.3152 24.8374 48.3557C24.8374 44.3963 21.6277 41.1865 17.6682 41.1865C13.7088 41.1865 10.499 44.3963 10.499 48.3557C10.499 52.3152 13.7088 55.5249 17.6682 55.5249Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.72493 75.4733L3.00052 70.4414C0.753609 68.4635 0.68386 64.9761 2.86601 62.9235C5.80543 60.1634 9.92561 56.661 13.5526 54.9023",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0229 75.4733L31.7473 70.4414C33.9943 68.4635 34.064 64.9761 31.8819 62.9235C28.9424 60.1634 24.8223 56.661 21.1953 54.9023",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.41317 76.0166C9.28862 69.6345 9.58755 65.1855 9.58755 65.1855",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8379 65.1855C24.8379 65.1855 25.4606 68.5684 25.4009 76.0166",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M70.4609 31.2227V59.9443H33.9473",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5098 37.3107V31.2227",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5698 24.945H72.4053L69.2118 17.5117H18.7633L15.5698 24.945Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M66.6798 35.9258H47.7778V59.9493H66.6798V35.9258Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3386 52.4463H41.7218V35.9258H22.8198V39.2488",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M63.437 43.5186V51.8386",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M70.4668 46.9115C70.4668 46.9115 71.0397 41.4263 75.3144 41.9046C78.2239 42.2284 74.024 46.9564 74.024 46.9564C74.024 46.9564 80.5704 45.392 82.5882 49.1236C84.6557 52.9448 75.5585 55.8842 75.5585 55.8842H85.981",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6262 31.9804H19.9786C17.5423 31.9804 15.5645 30.0025 15.5645 27.5663V24.9258H25.0354V27.5663C25.0404 30.0025 23.0625 31.9804 20.6262 31.9804Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1043 31.9804H29.4566C27.0204 31.9804 25.0425 30.0025 25.0425 27.5663V24.9258H34.5134V27.5663C34.5134 30.0025 32.5405 31.9804 30.1043 31.9804Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M39.574 31.9804H38.9263C36.4901 31.9804 34.5122 30.0025 34.5122 27.5663V24.9258H43.9831V27.5663C43.9881 30.0025 42.0102 31.9804 39.574 31.9804Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M49.0442 31.9804H48.3965C45.9603 31.9804 43.9824 30.0025 43.9824 27.5663V24.9258H53.4533V27.5663C53.4583 30.0025 51.4804 31.9804 49.0442 31.9804Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M58.5222 31.9804H57.8746C55.4383 31.9804 53.4604 30.0025 53.4604 27.5663V24.9258H62.9314V27.5663C62.9314 30.0025 60.9585 31.9804 58.5222 31.9804Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M67.99 31.9804H67.3423C64.9061 31.9804 62.9282 30.0025 62.9282 27.5663V24.9258H72.3991V27.5663C72.4041 30.0025 70.4262 31.9804 67.99 31.9804Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M69.2854 1.0166H18.7622V17.5122H69.2854V1.0166Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M38.4022 9.75537C38.3922 9.27709 38.5965 8.91838 38.8257 8.56964C39.0399 8.2458 39.3239 7.98674 39.6228 7.75258C39.9267 7.51344 40.2705 7.39387 40.6591 7.48853C40.958 7.56326 41.2619 7.65294 41.5509 7.75756C41.8149 7.85222 41.9195 8.10631 42.0242 8.34046C42.2185 8.76892 42.1886 9.21233 42.0541 9.65573C41.8647 10.2685 41.4961 10.7667 40.9879 11.1404C40.415 11.5639 39.6776 11.5987 39.015 11.1852C38.6413 10.9511 38.5118 10.5824 38.4421 10.1788C38.4172 10.0244 38.4122 9.86996 38.4022 9.75537ZM40.8634 9.06286C40.8683 8.78387 40.7488 8.66928 40.4449 8.69917C40.395 8.70415 40.3352 8.71412 40.2954 8.68921C40.1459 8.59455 40.0513 8.68423 39.9516 8.77889C39.7822 8.94329 39.7175 9.15254 39.6378 9.37175C39.563 9.581 39.5132 9.78028 39.5431 9.99949C39.568 10.1788 39.7025 10.3831 39.8271 10.3582C39.9915 10.3233 40.1708 10.2885 40.3054 10.1938C40.679 9.92476 40.8384 9.53616 40.8634 9.06286Z",
  fill: "#4C2C89"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7554 10.3036C51.606 10.2936 51.5013 10.2588 51.4166 10.2837C51.048 10.3783 50.6793 10.473 50.3256 10.6075C49.6928 10.8467 49.08 11.1256 48.4473 11.3648C47.8893 11.574 47.3264 11.7833 46.7534 11.9228C46.4944 11.9826 46.1456 11.9577 45.9214 11.8281C45.3983 11.5242 45.3236 11.0459 45.8068 10.5677C46.046 10.3335 46.2652 10.0744 46.5043 9.84027C46.8331 9.52142 47.1769 9.22748 47.5107 8.91361C47.71 8.73425 47.8993 8.54493 48.0936 8.35561C48.1335 8.31576 48.1534 8.25597 48.2331 8.12644C47.9591 8.14139 47.7399 8.13142 47.5256 8.16131C47.0822 8.22608 46.6936 8.15135 46.3349 7.84744C46.0559 7.61329 45.9862 7.2197 46.0808 6.96063C46.1755 6.70655 46.4844 6.52221 46.8381 6.56207C47.4659 6.6368 48.0986 6.72149 48.7164 6.84106C49.1199 6.92078 49.5235 7.04533 49.9121 7.19479C50.0715 7.25956 50.2259 7.42397 50.3056 7.57841C50.475 7.91719 50.3754 8.11648 50.0466 8.35063C49.5932 8.67945 49.1498 9.02321 48.7114 9.37196C48.4872 9.55131 48.2829 9.75558 48.0637 9.9449C48.0786 9.97479 48.0986 10.0047 48.1135 10.0296C48.3327 9.96482 48.547 9.90006 48.7662 9.83529C49.4985 9.62604 50.2209 9.37196 50.9633 9.21253C51.322 9.1378 51.6857 9.33708 51.9497 9.6111C52.0145 9.67586 51.9846 9.82533 51.9946 9.93991C51.9995 10.0296 51.7903 10.3086 51.7554 10.3036Z",
  fill: "#4C2C89"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M38.8257 11.4199C38.8357 11.4199 38.8456 11.4249 38.8556 11.4249C38.462 11.0761 38.2179 10.837 38.0086 10.6875C38.0136 10.7025 38.0136 10.7124 38.0136 10.7274C37.5901 10.4633 37.1168 10.1744 36.5937 9.85055C36.8528 9.73098 37.0919 9.62137 37.3261 9.51675C37.351 9.50678 37.3759 9.49184 37.4058 9.48187C37.5054 9.43704 37.6051 9.3922 37.6997 9.34736C38.1332 9.13313 38.6663 8.76446 38.6912 8.057V8.05202C38.6663 7.74811 38.4869 7.51894 38.188 7.41431C37.8492 7.28976 37.4805 7.225 37.1218 7.1951C36.2201 7.12037 35.3632 7.36948 34.5212 7.62854C34.2571 7.70826 34.0429 7.87266 34.0579 8.18155C34.0877 8.82424 33.8337 9.38722 33.5995 9.95517C33.3952 10.4534 33.181 10.9466 32.9967 11.4498C32.8871 11.7437 32.9917 11.9181 33.2807 12.0377C33.3853 12.0825 33.4849 12.1373 33.5846 12.1871C33.8088 12.2918 34.1924 12.1274 34.2771 11.8982C34.3717 11.6441 34.4664 11.395 34.5511 11.1359C34.6956 10.7025 34.8151 10.6427 35.2486 10.7623C36.2848 11.0413 37.2065 11.5494 38.0286 12.227C38.2478 12.4064 38.457 12.4213 38.7011 12.4064C38.8008 12.4014 38.9004 12.3765 38.9901 12.3615C39.1396 12.0377 39.025 11.7487 38.8257 11.4199ZM35.5126 9.03847C35.6123 8.5851 36.4841 8.20148 37.0471 8.35094C36.9325 8.62496 35.956 9.06836 35.5126 9.03847Z",
  fill: "#4C2C89"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2362 7.59854C31.8227 7.78786 31.4042 7.96224 30.9957 8.16152C30.6519 8.33091 30.3779 8.63482 29.9743 8.6946C29.7252 8.72947 29.4761 8.7793 29.227 8.76435C28.9929 8.7494 28.5146 8.27112 28.5196 7.9174C28.5246 7.53378 28.7986 7.28467 29.222 7.22489C29.521 7.18005 29.8199 7.10034 30.1039 7.0007C30.8611 6.74661 31.6134 6.4726 32.3607 6.20356C32.4953 6.15374 32.6148 6.0541 32.7543 6.00926C32.9885 5.92955 33.2326 5.86977 33.4717 5.81496C34.1892 5.65055 34.9066 5.4712 35.629 5.33668C36.3115 5.20715 36.9991 5.12245 37.6866 5.02779C37.9606 4.99292 38.2396 4.98296 38.5136 4.99292C38.683 4.9979 38.8574 5.04772 39.0168 5.10751C39.3556 5.23206 39.4502 5.45127 39.3058 5.78507C39.2808 5.83987 39.2161 5.89468 39.1563 5.90962C38.9919 5.95446 38.8175 6.00428 38.6481 6.01424C37.6218 6.06905 36.6154 6.26833 35.619 6.50249C35.1407 6.61708 34.6625 6.74163 34.1842 6.8612C33.9799 6.91102 33.8753 7.02561 33.8055 7.23485C33.4518 8.31596 33.0782 9.38711 32.7045 10.4632C32.5052 11.0262 32.286 11.5842 32.0818 12.1472C31.9622 12.481 31.733 12.6255 31.4291 12.5358C31.0505 12.4262 30.8811 12.197 30.9907 11.8433C31.17 11.2554 31.3942 10.6824 31.5835 10.0946C31.8177 9.36718 32.0369 8.6398 32.2611 7.90743C32.286 7.82772 32.286 7.74302 32.296 7.65833C32.281 7.64338 32.2611 7.61847 32.2362 7.59854Z",
  fill: "#4C2C89"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M45.6967 7.78256C45.2932 7.14984 44.7451 6.76124 43.9082 6.73633C43.8085 6.75626 43.6441 6.78615 43.4847 6.81604C42.9018 6.92565 42.7722 7.49859 42.4385 7.85729C42.3936 7.90213 42.4086 8.00676 42.4036 8.08149C42.4036 8.37543 42.4384 8.67435 42.3986 8.9683C42.3139 9.58607 42.1794 10.1989 42.0847 10.8166C41.9801 11.4992 41.8755 12.1867 41.8107 12.8792C41.7709 13.2927 42.4733 13.6863 42.842 13.4771C43.1409 13.3077 43.1509 12.9938 43.1907 12.7049C43.2555 12.2316 43.3203 11.7583 43.3801 11.285C43.405 11.0907 43.4797 11.0159 43.6989 11.0159C44.0427 11.0159 44.4064 11.0159 44.6754 10.7519C44.9544 10.4729 45.2384 10.1889 45.4725 9.87503C45.9508 9.22737 46.18 8.53984 45.6967 7.78256ZM44.5409 9.0231C44.4313 9.3569 44.2519 9.62593 43.943 9.8003C43.8633 9.84016 43.7786 9.87005 43.6192 9.94478C43.684 9.54124 43.7338 9.22238 43.7786 8.90851C43.8135 8.66937 43.8434 8.42525 43.8882 8.19109C43.9032 8.10142 43.943 7.98185 44.0078 7.95694C44.0676 7.93203 44.1872 7.97686 44.2569 8.02668C44.6355 8.30568 44.6903 8.56475 44.5409 9.0231Z",
  fill: "#4C2C89"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M39.3535 12.1967L39.3735 12.1367C39.3685 12.1817 39.3535 12.1967 39.3535 12.1967Z",
  fill: "#4C2C89"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M59.4509 9.85V10.7368C59.3812 10.7916 59.3114 10.8863 59.2317 10.9012C58.584 11.0208 57.9264 11.0905 57.2887 11.245C56.1578 11.514 55.0318 11.808 53.9208 12.1467C53.313 12.3311 52.745 12.6449 52.1522 12.8642C51.8333 12.9837 51.4945 13.0385 51.1607 13.1083C50.8369 13.178 50.528 13.1182 50.2291 13.0385C50.2141 12.8691 49.8953 12.3361 49.965 12.2115C50.0946 11.9574 50.2739 11.6087 50.4981 11.5539C50.9116 11.4492 50.9166 11.1254 51.076 10.8713C51.2604 10.5774 51.5294 10.3333 51.7536 10.0592C51.8532 9.93967 51.9479 9.81512 52.0426 9.68559C52.0426 9.68559 52.0525 9.67064 52.0774 9.64573C52.1771 9.52118 52.5009 9.1276 53.2582 8.37032C53.2632 8.36534 53.2731 8.35538 53.2781 8.35039C53.7664 7.88208 54.3144 7.22943 54.3692 6.98531C54.2795 6.97036 54.1898 6.95043 54.1051 6.95043C53.577 6.95043 53.039 6.92054 52.5159 6.97036C52.0376 7.0152 51.5095 6.35258 51.5543 5.93409C51.5842 5.67004 51.9728 5.33624 52.2468 5.36613C53.3429 5.50065 54.4389 5.63018 55.53 5.77964C55.9236 5.83445 56.2624 6.00384 56.4318 6.4024C56.5364 6.63656 56.4816 6.86075 56.3122 7.02516C55.6845 7.63298 55.0218 8.20591 54.414 8.82867C53.8062 9.45143 53.2432 10.124 52.6653 10.7816C52.6354 10.8165 52.6205 10.8713 52.5707 10.9809C52.8696 10.9112 53.1187 10.8564 53.3678 10.8016C54.8823 10.4478 56.3919 10.0842 57.9114 9.74537C58.325 9.65072 58.7584 9.65071 59.1819 9.59093C59.3911 9.54609 59.3612 9.75036 59.4509 9.85Z",
  fill: "#4C2C89"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M33.3018 67.9555H74.6679L70.463 59.9443",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function Svg3Franqueado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 78,
    viewBox: "0 0 87 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Franqueado);
export default __webpack_public_path__ + "static/media/3-franqueado.a57be176a6f6b93e77c8059ec7d92aab.svg";
export { ForwardRef as ReactComponent };